$(document).ready(function () {
var $banner = $('.banner-list');
if ($banner.children().length > 1) {
  $banner.slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });
}
  
  $(".product-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });


function initArrivalSlider() {
    $('.new-arrival-sec .grid-items-inner').each(function () {
        var $slider = $(this);
        if (!$slider.length) return;
        if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
        }
        $slider.slick({
            infinite: false,
            slidesToShow: 3.4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.4
                    }
                }
            ]
        });
    });
}

$(document).ready(function () {
    initArrivalSlider();
});

$(document).on('shopify:section:load', function () {
    initArrivalSlider();
});
  
  $(".reviews-slider").slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });
  
  $(".video-slider-sec .video-row").slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
     responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
        },
      },
    ],
  });

  
  $(document).on('click','.accordion details',function(e) {
    e.preventDefault();
    if($(this).attr('open')){
     $(this).attr('open', false); 
    }else{
      $('.accordion details').attr('open', false);
      $(this).attr('open', true); 
    }
  });
  
});


$(document).ready(function () {

    function initCollectionSlider($slider) {

        if (!$slider.length) return;

        if ($slider.hasClass("slick-initialized")) {
            $slider.slick("unslick");
        }

        $slider.slick({
            infinite: false,
            slidesToShow: 3.4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2.4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.4
                    }
                }
            ]
        });
    }


    // ===========================
    // Initialize Tabs
    // ===========================
    $(".tab-container").each(function () {

        var $container = $(this);

        $container.find(".tab_content").hide();

        $container.find("ul.tabs li").removeClass("active");
        $container.find("ul.tabs li:first").addClass("active");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $container.find(".tab_drawer_heading:first").addClass("d_active");

        var $firstContent = $container.find(".tab_content:first");

        // Temporarily make visible
        $firstContent.css({
            display: "block",
            visibility: "hidden"
        });

        initCollectionSlider(
            $firstContent.find(".product-list")
        );

        // Make visible after Slick is ready
        $firstContent.css({
            visibility: "visible"
        });
    });


    // ===========================
    // Common Tab Change
    // ===========================
    function changeTab($container, activeTab) {

        var $newContent = $container.find("#" + activeTab);

        if (!$newContent.length) return;

        // Hide current
        $container.find(".tab_content").hide();

        // Show new content but keep invisible
        $newContent.css({
            display: "block",
            visibility: "hidden"
        });

        // Initialize Slick BEFORE making it visible
        initCollectionSlider(
            $newContent.find(".product-list")
        );

        // Now show it
        $newContent.css({
            visibility: "visible"
        });
    }


    // ===========================
    // Tab Click
    // ===========================
    $("ul.tabs li").on("click", function (e) {

        e.preventDefault();

        var $this = $(this);
        var $container = $this.closest(".tab-container");
        var activeTab = $this.attr("rel");

        $container.find("ul.tabs li").removeClass("active");
        $this.addClass("active");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $container
            .find(".tab_drawer_heading[rel='" + activeTab + "']")
            .addClass("d_active");

        changeTab($container, activeTab);
    });


    // ===========================
    // Drawer Click
    // ===========================
    $(".tab_drawer_heading").on("click", function () {

        var $this = $(this);
        var $container = $this.closest(".tab-container");
        var activeTab = $this.attr("rel");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $this.addClass("d_active");

        $container.find("ul.tabs li").removeClass("active");
        $container
            .find("ul.tabs li[rel='" + activeTab + "']")
            .addClass("active");

        changeTab($container, activeTab);
    });


    // Last Tab Class
    $("ul.tabs li:last").addClass("tab_last");

});



// popup

$(document).ready(function() {

  $('.sm_open').on('click', function(){
      var modal = $(this).attr('data-modal');
      var modaloverlaycolor = $(this).attr('data-overlay');
      var modaleffect = $(this).attr('data-effect');
      var modalheader = $(this).attr('data-header');
      var modalheadertype = $(this).attr('data-header-type');
      var modalcontent = $(this).attr('data-content');
      var modaliconside = $(this).attr('data-icons');
      var modalwrappercolor = $(this).attr('data-wrapper-color');
  
      $('#' + modal).addClass(modaloverlaycolor);
      $('#' + modal + ' .sm_content').addClass(modaleffect);
      $('#' + modal + ' .sm_content .sm_header').html(modalheader);
      $('#' + modal + ' .sm_content .sm_header').addClass(modalheadertype);
      $('#' + modal + ' .sm_content .sm_area_all').html(modalcontent);
      $('#' + modal + ' .sm_icon_menu').addClass(modaliconside);
      $('#' + modal + ' .sm_content').addClass(modalwrappercolor);
      $('#' + modal).fadeIn().css("display", "flex");
      setTimeout(function(){
          $('#'+modal + ' .sm_content').addClass('show');
      }, 400);        
  });
  
  $('.sm_close').on('click', function(){
      var $modal = $(this).parents('.slim_modal');
      closeModal($modal);  
  });
  
  $('.slim_modal').on('click', function(e) {
    if (e.target !== this)
      return;
      var $modal = $(this);
      closeModal($modal);
  });
  
  function closeModal($modal) {
      $modal.find('.sm_content').removeClass('show');
      setTimeout(function(){
          $modal.removeClass('red green tan none');
          $modal.find('.sm_content').removeClass('red green tan');
          $modal.find('.sm_icon_menu').removeClass('is_right is_left');
          $modal.find('.sm_header').removeClass('detached');
          $modal.fadeOut();
      }, 400);
  }
});

$(document).ready(function() {
  $(".brand-logo-grid").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 2,
        },
      },
    ],
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const shopByBrands = document.querySelector('.shop-by-brands-section');

  if (!shopByBrands) return;

  const buttons = shopByBrands.querySelectorAll('.brand-filter-button');

  const brands = shopByBrands.querySelectorAll('.brands_logo');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const filter = this.dataset.filter;

      buttons.forEach(function (item) {
        item.classList.remove('active');
      });

      this.classList.add('active');

      brands.forEach(function (brand) {
        const letter = brand.dataset.brandLetter;

        if (filter === 'all' || letter === filter) {
          brand.classList.remove('hidden');
        } else {
          brand.classList.add('hidden');
        }
      });
    });
  });
});





